export enum ONLINE_ALERTS_TABS {
  BOND_ONLINE_ALERT_1 = 'bond-online-alert-1',
  BOND_ONLINE_ALERT_2 = 'bond-online-alert-2',
  BOND_ONLINE_ALERT_3 = 'bond-online-alert-3',
  BOND_ONLINE_ALERT_4 = 'bond-online-alert-4',
}
export const GRID_ONLINE_ALERT_TAB = 'grid-online-alert-tab';
